import { AgGridReact } from "ag-grid-react";
import ModalBasic from "../../pages/component/ModalBasic";

export const SelectItemListPopUp = (props) => {
    return (
        <ModalBasic
            id="voucher-receipt-details"
            classParams="!w-[75%]"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className="input-fields bg-white p-[30px] shadow-normalShadow rounded-[10px]">
                <div className="table w-full rounded-[10px] pb-[30px]">
                    <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                        <div className="table-inner">
                            <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">{props.modalName ? props.modalName : ""}</h1>
                        </div>
                        <AgGridReact
                            rowData={props.selectItemList} // Pass row data
                            rowHeight={40}
                            columnDefs={props.colDefs} // Pass column definitions
                            // pagination={true} // Enable pagination
                            // paginationPageSize={props.selectItemList?.length}
                            onCellClicked={props.handleSelectChange}
                        />
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}